import React from 'react';
import './ViewSearchBar.css';

interface ViewSearchBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  loading?: boolean;
}

export const ViewSearchBar: React.FC<ViewSearchBarProps> = ({
  searchQuery,
  onSearchChange,
  loading,
}) => {
  return (
    <div className="view-search-bar">
      <div className="vsb-search-wrapper">
        <svg className="vsb-search-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="6.5" cy="6.5" r="5" />
          <line x1="10" y1="10" x2="15" y2="15" />
        </svg>
        <input
          type="text"
          className={`vsb-search-input ${loading ? 'vsb-loading' : ''}`}
          placeholder="Search across columns..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
    </div>
  );
};
